import React from 'react';
import { remCss } from 'src/helpers';

const RecordingIcon = React.memo(({ width = '10', viewBox = '0 0 10 10' }) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={remCss(width)}
    height={remCss(width)}
    viewBox={viewBox}
  >
    <circle id='Ellipse_165' data-name='Ellipse 165' cx='5' cy='5' r='5' fill='#ff3030' />
  </svg>
));
RecordingIcon.displayName = 'RecordingIcon';

export default RecordingIcon;
